import { render, staticRenderFns } from "./MyTeam.vue?vue&type=template&id=f246371a&scoped=true"
import script from "./MyTeam.vue?vue&type=script&lang=js"
export * from "./MyTeam.vue?vue&type=script&lang=js"
import style0 from "./MyTeam.vue?vue&type=style&index=0&id=f246371a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f246371a",
  null
  
)

export default component.exports